import { render, staticRenderFns } from "./BuscaLocacoes.vue?vue&type=template&id=2a455148&scoped=true&"
import script from "./BuscaLocacoes.vue?vue&type=script&lang=js&"
export * from "./BuscaLocacoes.vue?vue&type=script&lang=js&"
import style0 from "./BuscaLocacoes.vue?vue&type=style&index=0&id=2a455148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a455148",
  null
  
)

export default component.exports